import { useEffect, useRef, useState } from 'react';
import { analyticsApi } from '../api/analyticsApi';

export default function AnalyticsCover({ accountId, mediaId, src, title }) {
  const [image, setImage] = useState(src);
  const [error, setError] = useState(null);
  const generation = useRef({ cancelled: false }), retried = useRef(false);
  useEffect(() => {
    const current = { cancelled: false };
    generation.current = current; retried.current = false; setImage(src); setError(null);
    return () => { current.cancelled = true; };
  }, [accountId, mediaId, src]);
  const failed = async () => {
    setImage(null);
    if (retried.current || !accountId || !mediaId) return;
    retried.current = true;
    const current = generation.current;
    try {
      const result = await analyticsApi.covers(accountId, [mediaId], true);
      if (generation.current === current && !current.cancelled) {
        setImage(result.covers[mediaId] || null);
        setError(result.errors?.[mediaId] || null);
      }
    } catch (failure) {
      if (generation.current === current && !current.cancelled) setError(failure.message || 'Cover could not be loaded.');
    }
  };
  return image ? <img loading="lazy" decoding="async" className="metrics-cover" src={image} alt="" width="44" height="44" onError={failed} />
    : <span className="metrics-cover metrics-cover-empty" title={error || title || 'Cover unavailable or loading'} aria-label={error || title || 'Cover loading'} />;
}
